import { render, staticRenderFns } from "./MainConstruirNumero.vue?vue&type=template&id=4de73da4"
import script from "./MainConstruirNumero.vue?vue&type=script&lang=js"
export * from "./MainConstruirNumero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports